import React, { useEffect, useState } from "react";
import { Accordion, Card, Col, Row } from "react-bootstrap";
import { FaAngleDoubleDown, FaFolderOpen, FaCalendarAlt } from "react-icons/fa";
import { format } from "date-fns";
import Message from "./Message";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { logout } from "../actions/userActions";
import Skeleton from "react-loading-skeleton";

import VisitSecretarySection from "./VisitSecretarySection";
import VisitNurseForm from "./VisitNurseForm";
import VisitNurseSection from "./VisitNurseSection";
import VisitPhysicianForm from "./VisitPhysicianForm";
import VisitPhysicianSection from "./VisitPhysicianSection";
import VisitDeleteButton from "./VisitDeleteButton";

const VisitAccordion = ({
  setVisitsVehicle,
  visit,
  isPhysician,
  isNurse,
  patientVehicle,
  expandAllRev,
  currentAge,
}) => {
  const [visitDate, setVisitDate] = useState(new Date(visit.visitDate));
  const [visitDay, setVisitDay] = useState(
    format(new Date(visit.visitDate), "yyyy-MM-dd"),
  );
  const [visitTime, setVisitTime] = useState(
    format(new Date(visit.visitDate), "HH:mm"),
  );

  return (
    <Accordion activeKey={expandAllRev && expandAllRev}>
      <Accordion.Toggle
        as={Card.Header}
        style={{
          background: visit.isClosed ? "#9FA6B2" : "#00abff",
          color: "white",
          cursor: "pointer",
        }}
        eventKey={expandAllRev ? expandAllRev : visit._id}
        variant="link"
      >
        <Row className="lead font-weight-bold justify-content-between text-center">
          <Col className="col-auto">
            {" "}
            <FaCalendarAlt />{" "}
            {visitDate &&
              `${format(new Date(visitDate), "dd-MMM-yyyy | hh:mm a")}`}
          </Col>
          <Col className="col-auto">
            <FaFolderOpen /> {visit?.clinicName}
          </Col>

          <Col className="col-auto arrow-container">
            {" "}
            <span>
              <FaAngleDoubleDown className="arrow-icon" size={20} /> Show
            </span>
          </Col>
        </Row>
      </Accordion.Toggle>

      <Accordion.Collapse eventKey={expandAllRev ? expandAllRev : visit._id}>
        <Card className="border-dark p-3">
          <>
            <VisitSecretarySection
              visit={visit}
              visitDate={visitDate}
              setVisitDate={setVisitDate}
              setVisitTime={setVisitTime}
              setVisitDay={setVisitDay}
              visitDay={visitDay}
              visitTime={visitTime}
              clinic={visit.clinicDetails}
            />

            {visit.nurseSection && (
              <VisitNurseSection
                visit={visit}
                currentAge={currentAge}
                clinic={visit.clinicDetails}
              />
            )}
            {isNurse && !visit.nurseSection && (
              <VisitNurseForm
                visit={visit}
                currentAge={currentAge}
                patientVehicle={patientVehicle}
                clinic={visit.clinicDetails}
                setVisitsVehicle={setVisitsVehicle}
              />
            )}
            {isPhysician && !visit.nurseSection && (
              <Message
                children={`Physician form is NOT available yet. Kindly wait while the nurse completes the routine screening.`}
                variant={`info`}
              />
            )}
            {visit.physicianSection && (
              <VisitPhysicianSection
                visit={visit}
                clinic={visit.clinicDetails}
              />
            )}
            {isPhysician && !visit.physicianSection && visit.nurseSection && (
              <VisitPhysicianForm
                visit={visit}
                clinic={visit.clinicDetails}
                setVisitsVehicle={setVisitsVehicle}
              />
            )}
            <VisitDeleteButton
              visit={visit}
              setVisitsVehicle={setVisitsVehicle}
            />
          </>
        </Card>
      </Accordion.Collapse>
    </Accordion>
  );
};

export default VisitAccordion;
